import styled from "styled-components";
import {PureButton} from "components";

export const CancelButton = styled(PureButton)`
	background: ${({theme}) => theme.button.cancel.background};
	color: #fff;
	border-radius: 50px;
	min-width: 120px;
	height: 32px;
	font-weight: 500;
	font-size: 14px;
	line-height: 160%;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.2s transform ease-in-out;
	@media (min-width: 1440px) {
		height: 40px;
	}
	@media (min-width: 1920px) {
		height: 50px;
	}

	&:hover:enabled {
		background: ${({theme}) => theme.button.cancel.hover.background};
		box-shadow: ${({theme}) => theme.button.cancel.hover.boxShadow};
	}
	&:disabled {
		background: #e5e5e5;
	}
`;
